export default {
    data() {
        return {
            editingTranscription: false,
        };
    },

    methods: {
        editTranscription() {
            if (this.editingTranscription) {
                // click handler will take care of disabling it.
                return;
            }

            const clickOutsideHandler = (e) => {
                const editorId = this.transcriptionEditorId || 'transcription-editor';
                const editorContainer = $(`.transcription-container #${editorId}`);

                if (!editorContainer.is(e.target) && editorContainer.has(e.target).length === 0) {
                    this.editingTranscription = false;
                    $(document).off('mousedown', clickOutsideHandler);
                }
            }

            this.editingTranscription = true;
            $(document).on('mousedown', clickOutsideHandler);
        },

        // Used when editing the full transcription.
        onUpdatedFullTranscription(value) {
            const chunks = value.split("\n");

            this.transcriptionChunks = chunks.map((chunk) => {
                return {
                    text: chunk,
                    timestamp: new Date(),
                };
            });
        },
    },

    computed: {
        canEditTranscription() {
            return this.$store.state.transcriptions?.can_edit_transcription;
        },

        fullTranscriptionForEditing() {
            return this.transcriptionChunks.map((chunk) => chunk.text).join('\n');
        },
    },
}
